import { render, staticRenderFns } from "./MixerUploadsList.vue?vue&type=template&id=34a079bb&lang=pug&"
import script from "./MixerUploadsList.vue?vue&type=script&lang=js&"
export * from "./MixerUploadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports